// Truncates to at most `max` UTF-16 code units — the unit C# String.Length uses. The note API caps on
// note.Trim().Length (code units), so a code-unit cap (not the code-point clampToMaxCharacters) is what
// keeps client and server in agreement; the surrogate-pair guard stops the cut from leaving a lone
// surrogate.
const HIGH_SURROGATE_START = 0xd800;
const HIGH_SURROGATE_END = 0xdbff;

const clampToMaxCodeUnits = (value, max) => {
    if (!value || value.length <= max) {
        return value;
    }
    let end = max;
    const boundaryCode = value.charCodeAt(end - 1);
    if (boundaryCode >= HIGH_SURROGATE_START && boundaryCode <= HIGH_SURROGATE_END) {
        end -= 1;
    }
    return value.slice(0, end);
};

export default clampToMaxCodeUnits;
